module.exports = __webpack_public_path__ + "img/step45_withe_lebel.7f8cb99d.png";